import axios from "axios"
import {TILE_URL} from "../globals"
import {generateFinalUrl} from "./utils"
import {handleError} from "../helpers/errors"


const URL = {
  LIST_AVAILABLE_TILES: "/tiles/list-available-tiles/{pk}",
  LIST_HISTOGRAM_CONFIGS: "/tiles/list-histogram-configs/{pk}",
  LIST_HISTOGRAM_CONFIGS_SHARED: "/tiles/list-histogram-configs-shared/{pk}",  
  ADD_UPD_HISTOGRAM_CONFIG: "/tiles/add-upd-histogram-config/",
}


const generateCommonHeader = (authToken) => {
  return {
    Authorization: `Bearer ${authToken}`,
  }
}


const axiosInstance = axios.create({
  baseURL: TILE_URL,
})
axiosInstance.interceptors.response.use(null, handleError)


//Tiles
export const listAvailableTiles = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_AVAILABLE_TILES, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listHistogramConfigs = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_HISTOGRAM_CONFIGS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const listHistogramConfigsShared = (pk) => {
  const url = generateFinalUrl(URL.LIST_HISTOGRAM_CONFIGS_SHARED, pk)
  return axiosInstance.get(url,
    {
      withCredentials: false,
    },
  )
}

export const addUpdHistogramConfig = (authToken, histogramConfigData) => {
  const url = generateFinalUrl(URL.ADD_UPD_HISTOGRAM_CONFIG)
  return axiosInstance.put(url,
    histogramConfigData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}
